import * as React from "react"
import Svg, { Path } from "react-native-svg"

function SvgComponent({color = '#000', props}: any) {
  return (
    <Svg
      width={70}
      height={70}
      viewBox="0 0 70 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Path
        d="M3.824 19.774l.032-.019L29.491 4.792a7.05 7.05 0 017.132 0l-32.8 14.982zm0 0v.037m0-.037v.037m0 0V50.23m0-30.418V50.23m0 0l.032.019m-.032-.02l.032.02m0 0l25.632 14.96-25.632-14.96zm29.2 15.928a7.038 7.038 0 01-3.568-.968l3.568.968zm0 0a7.05 7.05 0 003.564-.965l-3.564.965zm29.199-46.42L36.623 4.791l-.003 60.419 25.635-14.963.032-.02V19.775l-.032-.019zM30.919 7.125h0a4.226 4.226 0 014.278 0h0L58.18 20.543 33.056 35.22 7.93 20.548 30.92 7.126zm-.002 55.743h0L6.605 48.679V22.945l25.06 14.636V63.19a3.9 3.9 0 01-.748-.32zm4.277.003h0a3.897 3.897 0 01-.748.32V37.584l25.06-14.636V48.68L35.194 62.872z"
        fill={color}
        stroke={color}
        strokeWidth={0.13}
      />
    </Svg>
  )
}

export default SvgComponent
